import api from '../services/api'

function resolveMediaUrl(rawUrl) {
  if (!rawUrl) return null

  const urlString = typeof rawUrl === 'string' ? rawUrl.trim() : String(rawUrl).trim()
  if (!urlString || urlString === 'null' || urlString === 'undefined') {
    return null
  }

  // URLs que ya son válidas por sí mismas
  if (
    urlString.startsWith('http://') ||
    urlString.startsWith('https://') ||
    urlString.startsWith('data:') ||
    urlString.startsWith('blob:')
  ) {
    return urlString
  }

  // Si viene una ruta absoluta del backend (/storage, /uploads, etc), anexar host base
  const baseUrlFromEnv = (import.meta.env.VITE_API_URL || '').replace(/\/api\/?$/, '')
  const apiBase = api?.defaults?.baseURL
  const baseUrlFromApi =
    typeof apiBase === 'string' && apiBase.length > 0
      ? apiBase.startsWith('/')
        ? typeof window !== 'undefined'
          ? window.location.origin
          : ''
        : apiBase.replace(/\/api\/?$/, '')
      : ''
  const baseUrl =
    baseUrlFromEnv ||
    baseUrlFromApi ||
    (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:8000')
  if (urlString.startsWith('/')) {
    return `${baseUrl}${urlString}`
  }

  // Compatibilidad heredada: valores relativos se asumen bajo /storage
  if (urlString.startsWith('storage/')) return `${baseUrl}/${urlString}`
  if (urlString.startsWith('uploads/')) return `${baseUrl}/${urlString}`
  return `${baseUrl}/storage/${urlString}`
}

/**
 * Obtiene la URL completa del avatar de un usuario
 * @param {Object} user - Objeto de usuario
 * @returns {string|null} URL completa del avatar o null si no existe
 */
export function getAvatarUrl(user) {
  if (!user) return null
  
  const avatarUrl = user.avatar || user.foto
  return resolveMediaUrl(avatarUrl)
}

/**
 * Obtiene las iniciales del usuario para mostrar cuando no hay avatar
 * @param {Object} user - Objeto de usuario
 * @returns {string} Iniciales del usuario (ej: "JD" para "Juan Doe")
 */
export function getUserInitials(user) {
  if (!user) return 'U'
  
  const nombre = user.nombre || ''
  const apellido = user.apellido || ''
  
  const firstInitial = nombre?.[0]?.toUpperCase() || ''
  const lastInitial = apellido?.[0]?.toUpperCase() || ''
  
  if (firstInitial && lastInitial) {
    return `${firstInitial}${lastInitial}`
  }
  
  if (firstInitial) {
    return firstInitial
  }
  
  return 'U'
}

/**
 * Normaliza la URL de una foto/imagen (para mascotas u otros recursos)
 * @param {string|null|undefined} fotoUrl - URL de la foto
 * @returns {string|null} URL completa de la foto o null si no existe
 */
export function normalizeFotoUrl(fotoUrl) {
  return resolveMediaUrl(fotoUrl)
}
